import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FloorMapService {
  userToken: string;

  constructor(private http: HttpClient, @Inject('apiEndPoint') private apiEndPoint: string, @Inject('fileServerUrl') private fileServerUrl: string,) {
  }
  /*-- Import user API --*/
  importFloors(excelfile: any): any {
    return new Promise((resolve, reject) => {
      const formatData = new FormData();
      formatData.append('excelFile', excelfile);
      this.http.post(this.apiEndPoint + '/api/v1/floorMaps/import', formatData).subscribe(data => {
        resolve(data);
      }, error => {
        reject(error);
      });
    });
  }
  postFloorMapData(data: any) {
    return this.http.post(this.apiEndPoint + '/_/filterlist', data)
      .pipe(
        catchError((err) => {
          return throwError(JSON.stringify(err));    //Rethrow it back to component
        })
      )
  }
  getFloorMapDropdownData() {
    return this.http.get(this.apiEndPoint + '/gwdevice/maplist/_search?pretty&size=5000')
  }
  getGeoCoordinates(address) {
    return this.http.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=AIzaSyC-_X985YnPXOeDchKKO5A0VBoliZERR2w&language=en')
  }
  getRegions() {
    return this.http.get('assets/jsons/countries.json')
  }
  deleteRecord(recordID: any) {
    return this.http.delete(this.apiEndPoint + '/gwdevice/maplist/' + recordID)
  }
  addMapData(formData: any) {

    return this.http.post(this.apiEndPoint + '/gwdevice/maplist/_create', formData);

  }
  updateMapData(formData: any, id: any) {

    return this.http.put(this.apiEndPoint + `/gwdevice/maplist/${id}/_update`, formData);

  }
  checkMap(id: any) {
    let formData = {
      "maps": [id]
    }
    return this.http.post(this.apiEndPoint + `/_/2.0/checkmap`, formData);

  }
  uploadFile(file: any, type: any) {
    const data = new FormData();
    // data.append('pdf', file)
    data.append('pdf', file, file.updatedName);
    let api = type == 'PDF' ? '/single' : '/upload'
    return this.http.post(this.fileServerUrl + api, data);
  }
  getMapFile(file:string){
    return this.http.get(`${this.fileServerUrl}/${file}`,{
      responseType: 'blob'
    });
  
  }

  getAllLocations(mapid:any){
    const filter = {"query":{"bool":{"must":[
        {"query_string":{ "query":`\"${mapid}\"`, "type": "phrase", "fields": ["mapid"] } }
   ]
       }},"sort":{"_kuzzle_info.createdAt":"desc"}}
    return this.http.post(`${this.apiEndPoint}/gwdevice/devicestaticlocation/_search?size=100`, filter)
}

clearLocations(devices=[]){
  
  const filter = {body:{"ids": devices}};
  return this.http.delete(`${this.apiEndPoint}/gwdevice/devicestaticlocation/_mDelete`, filter)
}
}
